/** Filipino: Workflows P6 (M26, DEC-099): ang apat na hakbang ng mga default na workflow. Isinasama sa `engage.workflows`. */
export const workflowsSystem = {
  steps: {
    notify_team: "Abisuhan ang mga miyembro ng team",
    route_handoff: "I-route ang handoff",
    assign_lead_owner: "Itakda ang may-ari ng lead",
    send_to_subscribed_endpoints: "Ipadala sa mga webhook endpoint",
  },
  summaries: {
    notify_team: "{{who}}: {{what}}",
    route_agent_settings: "Ayon sa handoff settings ng bawat assistant",
    route_team: "Sa team na {{name}}",
    route_user: "Kay {{name}}",
    owner_workspace_setting: "Ayon sa leads routing setting",
    owner_round_robin: "Salitan sa mga karapat-dapat na miyembro",
    owner_user: "Kay {{name}}",
    send_to_subscribed_endpoints: "Bawat event na sinusubaybayan ng mga endpoint",
  },
  incomplete: {
    recipient: "Piliin kung sino ang aabisuhan",
    notifyTitle: "Isulat ang pamagat ng abiso",
    routeTeam: "Piliin ang team",
    routeUser: "Piliin ang tao",
    ownerUser: "Piliin ang tao",
  },
  fields: {
    olderStep: "Mas lumang hakbang ito. I-convert ito sa Notify team members para mapili kung sino ang aabisuhan, ayon sa sarili nilang notification settings.",
    convertStep: "I-convert sa Notify team members",
  },
  system: {
    notify: {
      category: "Uri ng abiso",
      categoryHint: "Sa Settings → Notifications pinipili ng mga miyembro kung paano nila natatanggap ang bawat uri.",
      categories: {
        handoff_requested: "Handoff",
        source_processed: "Tapos na ang knowledge sync",
        source_failed: "Pumalya ang knowledge sync",
        knowledge_gap: "Knowledge gap",
        lead_assigned: "Naitalaga ang lead",
        new_lead: "Bagong lead",
        new_booking: "Bagong booking",
        workflow: "Workflow",
        ticket_new: "Bagong ticket",
        ticket_assigned: "Naitalaga ang ticket",
        ticket_client_replied: "Sumagot ang kliyente",
        ticket_mention: "Binanggit sa ticket",
        ticket_sla: "SLA ng ticket",
        ticket_csat_low: "Mababang rating",
        ticket_returned_to_queue: "Bumalik sa pila ang ticket",
      },
      who: "Sino ang aabisuhan",
      recipient: "Tatanggap {{n}}",
      target: "Abisuhan",
      targets: {
        assignee: "Ang taong pinagtalagahan ng usapan",
        handoff_audience: "Kung kanino mapupunta ang handoff",
        queue_audience: "Ang humahawak ng queue ng team",
        reminder_audience: "Ang dapat sumagot, at ang team lead",
        returned_audience: "Ang team na binalikan ng usapan",
        team: "Isang team",
        team_of_conversation: "Ang team ng usapan",
        team_lead: "Ang team lead",
        team_mailbox: "Ang shared mailbox ng team",
        lead_owner: "Ang may-ari ng lead",
        leads_mailbox: "Ang leads mailbox",
        gap_assignee: "Ang taong pinagtalagahan ng gap",
        source_uploader: "Ang nagdagdag ng source",
        owners: "Mga Owner",
        owners_admins: "Mga Owner at Admin",
        owners_admins_for_agent: "Mga Owner at Admin na nakakakita ng inbox ng assistant",
        workspace_owner: "Ang may-ari ng workspace",
        permission: "Lahat ng may pahintulot",
        user: "Isang tao",
        ticket_audience: "Kung sino ang hahawak ng ticket",
        team_of_ticket: "Ang team ng ticket",
        mentioned: "Ang mga binanggit sa tala",
      },
      teamNamed: "Ang team na {{name}}",
      permissionNamed: "Lahat ng may {{permission}}",
      permission: "Pahintulot",
      permissionHint: "Lahat ng may hawak nito (para sa inbox ng assistant, sa saklaw ng assistant na iyon).",
      delivery: "Paano nila ito matatanggap",
      deliveryHint: "Aabot nang direkta ang abiso sa tao kahit i-off nila ang ganitong uri. Gamitin lang kung saan ito palaging ganoon.",
      deliveries: { preferences: "Ayon sa notification settings nila", direct: "Direkta, anuman ang settings nila" },
      addRecipient: "Magdagdag ng tatanggap",
      removeRecipient: "Alisin ang tatanggap {{n}}",
      maxRecipients: "Hanggang {{max}} grupo ang maaabisuhan ng isang hakbang.",
      excludeActor: "Huwag isama ang miyembrong gumawa nito",
      channels: "Mga channel",
      channelOptions: { in_app: "Sa app", email: "E-mail" },
      channelsAll: "Ang sariling settings ng bawat miyembro ang masusunod.",
      channelsCapped: "Ang mga channel na ito lang, at kung pinapayagan lang ng miyembro.",
      channelsFromSource: "Sumusunod ang mga channel sa notification setting ng knowledge source.",
      outOfHours: "Labas ng office hours",
      outOfHoursHint: "Para sa handoff na dumating habang sarado ang opisina.",
      outOfHoursRules: { same: "Ipadala sa parehong paraan", in_app_only: "Sa app lang" },
      standardShort: "Karaniwang mensahe",
    },
    route: {
      note: "Nagpapasya kung kanino mapupunta ang bagong handoff, sa simula nito. Gumagana lang ito sa default na workflow na ito; sa mga workflow ninyo, gamitin ang Assign.",
      mode: "I-route sa",
      modes: { agent_settings: "Handoff settings ng bawat assistant", team: "Palaging isang team", user: "Palaging isang tao" },
      roundRobin: "Sa loob ng team",
      roundRobinHint: "Kung isang miyembro ng team o ang buong team ang pagbibigyan ng handoff.",
      roundRobins: { team_setting: "Sundin ang setting ng team", on: "Salitan ang mga miyembro", off: "Ang buong team" },
      agentSettingsHint: "May sariling default na team o tao ang bawat assistant sa handoff settings nito.",
    },
    owner: {
      note: "Nagpapasya kung sino ang may-ari ng bagong lead, kapag nakuha ito. Gumagana lang ito sa default na workflow na ito; sa mga workflow ninyo, gamitin ang Update lead.",
      mode: "Ibigay ang lead kay",
      modes: { workspace_setting: "Kung sino ang sinasabi ng leads routing setting", round_robin: "Mga miyembro nang salitan", user: "Palaging isang tao" },
      workspaceSettingHint: "Palitan ang mismong patakaran sa Settings → Leads routing.",
    },
    endpoints: {
      body: "Ipinapadala ang bawat event sa mga webhook endpoint na sumusubaybay dito, may lagda, may retry at delivery log.",
      hint: "Walang itatakda rito. Ang bawat endpoint ang pumipili ng sarili nitong mga event.",
      link: "Buksan ang webhook settings",
    },
  },
};
